<!-- Navigation -->
<header class="fixed w-full z-50 glass">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between items-center h-20">
            <!-- Logo -->
            <div class="flex-shrink-0 flex items-center">
                <a href="/">
                    <img
                        class="h-12 w-auto"
                        src="../../../assets/images/logo/logo.png"
                        alt="AethyrTech"
                    />
                </a>
            </div>

            <!-- Desktop Menu -->
            <nav class="hidden md:flex space-x-8">
                <a
                    routerLink="/"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{ exact: true }"
                    class="nav-link"
                    >Home</a
                >
                <a routerLink="/platform" routerLinkActive="active" class="nav-link">Platforms</a>
                <a routerLink="/market" routerLinkActive="active" class="nav-link">Market</a>
                <a routerLink="/pricing" routerLinkActive="active" class="nav-link">Pricing</a>
                <a routerLink="/about" routerLinkActive="active" class="nav-link">About Us</a>
                <a routerLink="/contact" routerLinkActive="active" class="nav-link">Contact</a>
            </nav>

            <!-- Login Button -->
            <div class="hidden md:flex items-center">
                <a
                    (click)="loginDialog()"
                    (keydown.enter)="loginDialog()"
                    tabindex="0"
                    class="text-sm font-semibold text-gray-600 hover:text-[#ef4444] transition-colors mr-4 cursor-pointer"
                >
                    <i class="fa-solid fa-lock mr-2"></i>Login
                </a>
                <a href="/contact" class="btn-primary text-sm"> Get Started </a>
            </div>

            <!-- Mobile Menu Button -->
            <div class="md:hidden flex items-center">
                <button
                    id="mobile-menu-btn"
                    class="text-gray-600 hover:text-gray-900 focus:outline-none"
                >
                    <i class="fa-solid fa-bars text-2xl"></i>
                </button>
            </div>
        </div>
    </div>

    <!-- Mobile Menu (Hidden by default) -->
    <div
        id="mobile-menu"
        class="hidden md:hidden bg-white border-t border-gray-100 absolute w-full left-0 shadow-lg max-h-[80vh] overflow-y-auto"
    >
        <div class="px-4 pt-2 pb-6 space-y-2">
            <a
                routerLink="/"
                routerLinkActive="bg-red-50 text-[#ef4444]"
                [routerLinkActiveOptions]="{ exact: true }"
                class="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-[#ef4444] hover:bg-red-50 transition-colors"
                >Home</a
            >
            <a
                href="/platform"
                class="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-[#ef4444] hover:bg-red-50 transition-colors"
                >Platform</a
            >
            <a
                href="/market"
                class="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-[#ef4444] hover:bg-red-50 transition-colors"
                >Market</a
            >
            <a
                href="/pricing"
                class="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-[#ef4444] hover:bg-red-50 transition-colors"
                >Pricing</a
            >
            <a
                href="/about"
                class="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-[#ef4444] hover:bg-red-50 transition-colors"
                >About Us</a
            >
            <a
                href="/contact"
                class="block px-3 py-3 rounded-md text-base font-medium text-gray-700 hover:text-[#ef4444] hover:bg-red-50 transition-colors"
                >Contact</a
            >
            <div class="border-t border-gray-100 pt-4 mt-4">
                <a
                    (click)="loginDialog()"
                    (keydown.enter)="loginDialog()"
                    tabindex="0"
                    class="block w-full text-center px-4 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-[#ef4444] hover:bg-[#dc2626] transition-colors cursor-pointer"
                >
                    <i class="fa-solid fa-lock mr-2"></i>Login
                </a>
            </div>
        </div>
    </div>
</header>
